module.exports = __webpack_public_path__ + "img/water06_selected.f89c746d.png";